import { render, staticRenderFns } from "./EditContentTypeComponent.vue?vue&type=template&id=45d30c2d&scoped=true"
import script from "./EditContentTypeComponent.vue?vue&type=script&lang=js"
export * from "./EditContentTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d30c2d",
  null
  
)

export default component.exports